import { LogsService } from "@gtpl/shared-services/user-logs";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ShiftsEntity } from "./entities/shifts.entity";
import { ShiftAdapter } from "./shifts.adapter";
import { ShiftsController } from "./shifts.controller";
import { ShiftService } from "./shifts.service";

@Module({
  imports: [
    TypeOrmModule.forFeature([ShiftsEntity]),
  ],
  controllers: [ShiftsController],
  providers: [ShiftService, ShiftAdapter, ApplicationExceptionHandler,LogsService],
  exports: [ShiftService]
})
export class ShiftModule {}